"use client";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

import { useEffect, useState } from "react";
import { DirectusImage } from "@/components/DirectusImage";
import { ChevronsRight } from "lucide-react";

import PreviewImage from "@/components/clients/PreviewImage";
import { useScopedI18n } from "@/messages/client";

export default function EnvDeclarationClient(props: {
  data: {
    name?: string;
    image?: string;
    icon?: string;
    file?: string;
  }[];
}) {
  const t = useScopedI18n("质量与可靠性");

  const [isMobile, setIsMobile] = useState<boolean>();

  useEffect(() => {
    const listener = () => {
      setIsMobile(window.matchMedia("(max-width: 768px)").matches);
    };
    listener();
    window.addEventListener("resize", listener);
    return () => {
      window.removeEventListener("resize", listener);
    };
  }, []);

  return (
    <div className="relative w-full">
      {!isMobile && (
        <>
          <Carousel className="relative md:mt-11" opts={{ loop: true }}>
            <CarouselContent className="-ml-4">
              {props.data?.map((el, index) => (
                <CarouselItem key={index} className="basis-1/4 pl-4">
                  <div className="relative h-[400px] w-full overflow-hidden rounded-md">
                    <DirectusImage
                      zoomIn
                      id={el.image || ""}
                      alt={el.name || ""}
                      fill
                      className="object-cover object-center"
                    />

                    <div className="absolute bottom-0 left-0 right-0 h-[80px] bg-[#383838] bg-opacity-50 px-8 py-4 text-white">
                      <div className="text-lg font-medium line-clamp-1" title={el.name}>
                        {el.name}
                      </div>
                      {el.file && (
                        <a
                          href={`${process.env.NEXT_PUBLIC_DIRECTUS_ASSETS}/${el.file}/${el.name}`}
                          target="_blank"
                          className="flex items-center space-x-1 transition-colors duration-300 hover:text-primary">
                          <div className="text-xs font-medium">
                            {t("点击查看")}
                          </div>

                          <ChevronsRight className="text-primary" size={14} />
                        </a>
                      )}
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>

            <CarouselPrevious className="left-2 select-none border-none xl:left-[-3vw]" />
            <CarouselNext className="right-2 select-none border-none xl:right-[-3vw]" />
          </Carousel>
        </>
      )}
      {isMobile && (
        <div className="mt-5 grid grid-cols-3 gap-3">
          {props.data?.map((el, index) => (
            <PreviewImage key={index} image={el.image || ""}>
              <div className="flex h-[100px] w-[100px] flex-col items-center justify-center rounded-lg bg-[#F7F7F7]">
                <div className="relative h-6 w-6 flex-shrink-0">
                  <DirectusImage id={el.icon || ""} alt={el.name || ""} fill />
                </div>
                <div className="mt-2 px-4">
                  <div className="whitespace-nowrap text-center text-[0.625rem] font-medium">
                    {el.name}
                  </div>
                  {el.file && (
                    <a
                      href={`${process.env.NEXT_PUBLIC_DIRECTUS_ASSETS}/${el.file}/${el.name}`}
                      target="_blank"
                      className="mt-0.5 flex items-center justify-center">
                      <div className="text-[0.625rem] font-medium text-[#808080]">
                        {t("点击查看")}
                      </div>

                      <ChevronsRight className="text-primary" size={12} />
                    </a>
                  )}
                </div>
              </div>
            </PreviewImage>
          ))}
        </div>
      )}
    </div>
  );
}
